angular.module('cvsApp').service('lookupDemographicalInformation', ['networkService', 'xdrService', 'configManager', 'commonModel', 'lookupDemographicalInformationModel', function (NS, XS, CM, CMOD, LDIM) {

	function lookupDemographicalInformationService() {
		var self = this;
		this.lookUp = function (data, callBackSuccess) {

			 var url = CM.getAPIGEEAPIUrl('LOOKUP_DEMOGRAPHIC_INFO_APIGEE');
			if (url === "URL_ERROR") {

			} else {
				var request = {
					url: url,
					header: {
						"Content-Type": "application/json",
						"Accept": "application/json",
						'x-api-key': cvsUtility.queryMap.env == 'prod' ? 'BlmvsMWWqssGvPMVG1mA4kymUwWEqDmg' : 'I2u0gpuzIYHAc1yHqBAvCACQ1yUfhwjp'
					},

					data: data,
					onSuccess: callBackSuccess
				};

				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, "", xdrSuccess);

					function xdrSuccess(data) {
						LDIM.setResponse(data);
						callBackSuccess(LDIM.getResponse());
					}
				} else {
					var authPromise = NS.post(request);
					authPromise.then(function (data) {
						LDIM.setResponse(data.data);
						callBackSuccess(LDIM.getResponse());
					}, function (reason) {
						callBackSuccess(reason);
					});
				}

			}
		};
	}
	return new lookupDemographicalInformationService();
}]);
